// extracted by mini-css-extract-plugin
module.exports = {"ResultsContainer":"_11RWb","ResultsItem":"_2x-sv","Results":"wdH28"};